import { 
    Order_Create as oc, 
    Order_AddArticle as oac,
    Order_RemoveArticle as oar,
    Order_Retrive as or,
    Order_ChangeArticle as oca,
    Order_UpdateCustomer as uc,
    Order_SetOrderToWireTransfer as pd,
    Order_PayPalTransactionComplete as pp, Order_CloseOrder as close,
    Order_Reduction as reductionInfo,
    Order_AddReduction as reduction,
    Order_PrepareForCheckout as prepare,
    Order_RemoveReduction as remReduction,
    Order_OptinOptions as optinOptions,
    Order_OrderNotifications as notifications,
    Order_ClaimOrder as claim,
    Order_AmazonPayCreateCheckoutSession as amaCheckout,
    Order_AmazonPayProcessCheckoutSession as amaAuth,
    Order_AmazonPayCreateRedirect as amaRedirect,
    Order_AmazonPayCompletePayment as amaComplete,
    Order_MetaData,
    Order_AddGiftCard as addGiftCard,
    Order_RemoveGiftCard as removeGiftCard,
    Order_SelectedPayment as retriveSelectedPayment

} from "./backend"

let defaultCurrency = 'EUR';

export const setShopCurrency = (currency) => {
    defaultCurrency = currency;
}

const createOrder =  async () => {
    let { data } = await oc({
        cmd: {
            currency:  defaultCurrency
        }
    });
    if(data){
        localStorage.setItem('CURRENT_ID',data.id);
        localStorage.setItem('TOKEN', data.token);
    }
    return data;
}


const updateCurrentOrder = (id, token) => {
    localStorage.setItem('CURRENT_ID', id);
    localStorage.setItem('TOKEN', token);
}

const resetOrderStorage = () => {
    localStorage.removeItem('CURRENT_ID');
    localStorage.removeItem('TOKEN');
}

const closeOrder =  async () => {
    let { data } = await close({ cmd: {
        orderId: localStorage.getItem('CURRENT_ID'),
        key: localStorage.getItem('TOKEN')
    }});
    return data;
}

const createOrderIfNeeded = async () => {
    if(!localStorage.getItem('CURRENT_ID') || !localStorage.getItem('TOKEN')){
       return await createOrder();
    }else{
        return await checkOpenOrder();
    }
}


const checkOpenOrder = async () => {
    if(localStorage.getItem('CURRENT_ID') && localStorage.getItem('TOKEN')){
        let { data }  = await or({
            id: localStorage.getItem('CURRENT_ID'),
            key: localStorage.getItem('TOKEN')
        });
        return data;
    }else{
        return {};
    }
}

const get = async (id,key) => {
    let { data }  = await or({
        id: id,
        key: key
    });
    return data;
}

const metaData = async (id,key) => {
    let { data }  = await Order_MetaData({
        id: id,
        key: key
    });
    return data;
    
}

const addItem = async (variantId) => {

    let r = {
        orderId: localStorage.getItem('CURRENT_ID'),
        key: localStorage.getItem('TOKEN'),
        variantId: variantId,
        quantity: 1,
    }
    const stored = localStorage.getItem('referal')
    if (stored) {
      const ref = JSON.parse(stored)
      r.ref = ref.code;
      r.referer = ref.referer;
      r.refPath = ref.path;
      r.refPayload = ref.add;
      r.refUsed = ref.created
    }
    let { data } = await oac({ cmd: r });
    return data;
}

const removeItem = async (item) => {
    if(localStorage.getItem('CURRENT_ID') && localStorage.getItem('TOKEN')){
        let { data } = await oar({ cmd: {
            orderId: localStorage.getItem('CURRENT_ID'),
            key: localStorage.getItem('TOKEN'),
            itemId: item.id
        }});
        return data;
    }
}

const changeQuantity = async (itemId, quantity) => {
    let { data } = await oca({ cmd: {
        orderId: localStorage.getItem('CURRENT_ID'),
        key: localStorage.getItem('TOKEN'),
        itemId: itemId,
        quantity: quantity
    }});
    return data;
}

const updateUserData = async (userData) => {
    let tmp = userData;
    tmp.orderId = localStorage.getItem('CURRENT_ID');
    tmp.key = localStorage.getItem('TOKEN');
    let { data }  = await uc({ cmd: tmp });
    return data;
}

const addGiftCardToOrder = async (tan) => {
    let { data } = await addGiftCard({ cmd: {
        orderId: localStorage.getItem('CURRENT_ID'),
        key: localStorage.getItem('TOKEN'),
        tan: tan
    }});
    return data;
}

const removeGiftCardFromOrder = async (tan) => {
    let { data } = await removeGiftCard({ cmd: {
        orderId: localStorage.getItem('CURRENT_ID'),
        key: localStorage.getItem('TOKEN'),
        tan: tan,
    }});
    return data;
}


const setWireTransfer = async () => { 
    let { data }  = await pd({ cmd: {
        orderId: localStorage.getItem('CURRENT_ID'),
        key: localStorage.getItem('TOKEN')
    }});
    return data;
}

const refreshPaymentType = async () => { 
    let { data }  = await retriveSelectedPayment( {
        id: localStorage.getItem('CURRENT_ID'),
        key: localStorage.getItem('TOKEN')
    });
    return data;
}

const completePayPalTransaction = async (paypalOrderId) => {
    let { data }  = await pp({ cmd: {
        orderId: localStorage.getItem('CURRENT_ID'),
        key: localStorage.getItem('TOKEN'),
        payPalOrderId: paypalOrderId
    }});
    return data;
}

const applyReduction = async (code) => {
    let { data }  = await reduction({ cmd: {
        orderId: localStorage.getItem('CURRENT_ID'),
        key: localStorage.getItem('TOKEN'),
        code: code
    }});
    return data;
}

const removeReduction = async () => {
    let { data }  = await remReduction({ cmd: {
        orderId: localStorage.getItem('CURRENT_ID'),
        key: localStorage.getItem('TOKEN')
    }});
    return data;
}


const getReductionInfo = async (id) => {
    let { data } = await reductionInfo({id: id});
    return data;
}

const prepareForCheckout = async() => {
    let { data } = await prepare({
        id: localStorage.getItem('CURRENT_ID'),
        key: localStorage.getItem('TOKEN')
    });
    return data;
}

const createAmazonCheckoutSession = async () => {
    let { data } = await amaCheckout({
        cmd: {
            orderId: localStorage.getItem('CURRENT_ID'),
            key: localStorage.getItem('TOKEN')
        }
    });
    return data;
}

const authorizeAmazonCheckoutSession = async (session) => {
    let { data } = await amaAuth({
        cmd: {
            orderId: localStorage.getItem('CURRENT_ID'),
            key: localStorage.getItem('TOKEN'),
            amazonCheckoutSessionId: session
        }
    });
    return data;
}

const createAmazonPayRedirect = async (session) => {

    let { data } = await amaRedirect({
        cmd: {
            orderId: localStorage.getItem('CURRENT_ID'),
            key: localStorage.getItem('TOKEN'),
            amazonCheckoutSessionId: session
        }
    });
    return data;
}

const completeAmazonPayPayment = async (session) => {

    let { data } = await amaComplete({
        cmd: {
            orderId: localStorage.getItem('CURRENT_ID'),
            key: localStorage.getItem('TOKEN'),
            amazonCheckoutSessionId: session
        }
    });
    return data;
    
}

const setOptinOptions = async (email, phone, newsletter) => {
    let { data } = await optinOptions({
        cmd: {
            orderId: localStorage.getItem('CURRENT_ID'),
            key: localStorage.getItem('TOKEN'),
            optinEmail: email,
            optinPhone: phone,
            optinNewsletter: newsletter
        }
    });
    return data;
}

const getOrderNotifications = async() => {
    try {
        let { data } = await notifications({
            id: localStorage.getItem('CURRENT_ID'),
            key: localStorage.getItem('TOKEN')
        });
        return data;
    }catch{
        return [];
    }
}

const claimOrder = async (id, token) => {
    let { data } = await claim({
        req: {
            orderId: id,
            token: token
        }
    });
    return data;
}



export default {
    checkOpenOrder,
    addItem,
    removeItem,
    createOrderIfNeeded,
    changeQuantity,
    updateUserData,
    setWireTransfer,
    completePayPalTransaction,
    get,
    closeOrder,
    applyReduction,
    getReductionInfo,
    removeReduction,
    prepareForCheckout,
    setOptinOptions,
    getOrderNotifications,
    updateCurrentOrder,
    claimOrder,
    createAmazonCheckoutSession,
    authorizeAmazonCheckoutSession,
    createAmazonPayRedirect,
    completeAmazonPayPayment,
    resetOrderStorage,
    metaData,
    addGiftCardToOrder,
    removeGiftCardFromOrder,
    refreshPaymentType
}